export default __webpack_public_path__ + "static/media/no.50aa6be0.png";